export { EloCertificateIcon } from './certificate-icon'
